module.exports = __webpack_public_path__ + "static/media/socialPic.32090659.PNG";